import { useState, useEffect } from "react";
export var useSession = function () {
    var _a = useState(null), session = _a[0], setSession = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    useEffect(function () {
        try {
            var storedSession = localStorage.getItem("session");
            setSession(storedSession);
        }
        catch (err) {
            setError(err instanceof Error ? err : new Error("Failed to read session"));
        }
    }, []);
    var updateSession = function (newSession) {
        try {
            localStorage.setItem("session", newSession);
            setSession(newSession);
        }
        catch (err) {
            setError(err instanceof Error ? err : new Error("Failed to update session"));
        }
    };
    var clearSession = function () {
        localStorage.removeItem("session");
        setSession(null);
    };
    var logout = function () {
        // Clear all storage
        localStorage.clear();
        sessionStorage.clear();
        // Redirect to root path
        window.location.href = "/";
    };
    return {
        session: session,
        error: error,
        updateSession: updateSession,
        clearSession: clearSession,
        isAuthenticated: !!session,
        logout: logout,
    };
};
